import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'

import dashboard from './dashboard'
import casos from './casos'
import usuarios from './usuarios'
import contactos from './contactos'
import procesos from './procesos'
import pasos from './pasos'
import multityping from './multityping'
import reportedash from './reportedash'

import cuentas from './cuentas'
import grupos from './grupos'
import roles from './roles'
import acuerdos from './acuerdos'
import prioridades from './prioridades'
import categorias from './categorias'
import subcategorias from './subcategorias'
import productos from './productos'
import estados from './estados'
import tipos from './tipos'
import subtipos from './subtipos'
import empresas from './empresas'
import permisos from './permisos'
import navegacion from './navegacion'
import logauditoria from './logauditoria'
import notas from './notas'
import horarios from './horarios'
import horariosClientes from './horariosClientes'
import zonashorarias from './zonashorarias'
import dias from './dias'
import archivos from './archivos'
import extraccion from './extraccion'
import correos from './correos'
import actividadesprogramadas from './actividadesprogramadas'
import encuestas from './encuestas'
import customfields from './customfields'
import reportes from './reportes'
import proyectos from './proyectos'
import informes from './informes'
import parametros from './parametros'
import parametros_custom from './parametros_custom'
import reporteinc from './reporteinc'
import conceptos from './conceptos'
import estadisticas from './estadisticas'
import licencia from './licencia'
import sistemasexternos from './sistemasexternos'
import company from './company'
import complice from './complice'
import chequeo from './chequeo'
import misreportes from './misreportes'
import feriados from './feriados'
import misproyectos from './misproyectos'
import notificaciones from './notificaciones'
import redashboard from './redashboard'
import templatecorreo from './templatecorreo'
import personalizacion from './personalizacion'
import personalizacionDesk from './personalizacionDesk'
import loginPersonalizacion from './loginPersonalizacion'
import gruposkill from './gruposkill'
import gruposkillcal from './gruposkillcal'
import casocontactos from './casocontactos'
import imagenes from './imagenes'
import notasNotificacion from './notasNotificacion'
import archivosNotas from './archivosNotas'
import emails from './emails'
import formschema from './dynforms/formschema'
import formdata from './dynforms/formdata'
/* import appfoundry from './appfoundry/index' */
import representante from './representante'
import pcintegracion from './pcintegracion'
import actividades from './actividades'
import cargaMasiva from './cargaMasiva/index'
import customfieldsc from './customfieldsc'
import aplicacionesexternas from './aplicacionesexternas'
import paises from './paises'
import loggeneral from './loggeneral'
import geolocalizacion from './geolocalizacion'
import paramcasoscorreos from './paramcasoscorreos'
import casillascorreos from './casillascorreos'
import serviciotelefonico from './serviciotelefonico'
import serviciotelefonicoget from './serviciotelefonicoget'
import serviciotelefonicoadmin from './serviciotelefonicoadmin'
import parametrosAzure from './parametrosAzure'
import respuestaspredefinidas from './respuestaspredefinidas'
import listacorreos from './listacorreos'
import customfieldsvalues from './customfieldsvalues'
import segmentaciones from './segmentaciones'
import usuarioambiente from './usuarioambiente'
import ambientesdestino from './ambientesdestino'
import parametrosKeycloak from './parametrosKeycloak'
import keycloakIp from './keycloakIp'
import usuarioEstadoDefault from './usuarioEstadoDefault'
import rolEstadoDefault from './rolEstadoDefault'
import catalogodocumentos from './catalogodocumentos'
import gestordocumental from './gestordocumental'
import hyperpersonalization from './hyperpersonalization'
import perfilUsuarios from './perfilUsuarios'

import crudState from './utils/crud/state'
import * as crudGetters from './utils/crud/getters'
import * as crudMutations from './utils/crud/mutations'
import * as crudActions from './utils/crud/actions'
import get from 'lodash/get'

Vue.use(Vuex)

const moduloTab = {
  namespaced: true,
  state: () => ({
    endpoint: 'contacto',
    ...crudState(),

    correoTipos: [{ id: 0, value: 'Personal' }, { id: 1, value: 'Trabajo' }, { id: 2, value: 'Otro' }],
    telefonoTipos: [{ id: 0, value: 'Personal' }, { id: 1, value: 'Trabajo' }, { id: 2, value: 'Otro' }]
  }),
  getters: {
    ...crudGetters,

    correoTipos: state => state.correoTipos,
    telefonoTipos: state => state.telefonoTipos
  },
  mutations: {
    ...crudMutations
  },
  actions: {
    ...crudActions,
    async recuperarpass ({ commit, state }, params) {
      commit('setLoading', 1, { root: true })
      try {
        const response = await axios.post(`${state.endpoint}/recovery`, params)
        const message = get(response, 'data.message', {})
        const data = get(response, 'data.data', {})
        commit('setLoading', -1, { root: true })

        data.message = message
        return data
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    }
  }
}

export default new Vuex.Store({
  state: {
    open: false,
    loading: 0
  },
  getters: {
    open: state => state.open,
    loading: state => state.loading > 0
  },
  mutations: {
    setSidebarState (state) {
      state.open = !state.open
    },
    setLoading (state, value) {
      state.loading += value
    }
  },
  actions: {
    toggleSidebar ({ commit }) {
      commit('setSidebarState')
    }
  },
  modules: {
    mtab: moduloTab,
    auth,
    dashboard,
    casos,
    usuarios,
    contactos,
    procesos,
    pasos,
    cuentas,
    grupos,
    roles,
    acuerdos,
    prioridades,
    categorias,
    subcategorias,
    productos,
    estados,
    tipos,
    subtipos,
    empresas,
    permisos,
    navegacion,
    logauditoria,
    notas,
    horarios,
    horariosClientes,
    zonashorarias,
    dias,
    archivos,
    extraccion,
    correos,
    sistemasexternos,
    actividadesprogramadas,
    encuestas,
    customfields,
    reportes,
    proyectos,
    informes,
    parametros,
    parametros_custom,
    reporteinc,
    conceptos,
    estadisticas,
    company,
    licencia,
    complice,
    chequeo,
    multityping,
    misreportes,
    reportedash,
    feriados,
    misproyectos,
    notificaciones,
    redashboard,
    templatecorreo,
    personalizacion,
    personalizacionDesk,
    loginPersonalizacion,
    gruposkill,
    gruposkillcal,
    casocontactos,
    imagenes,
    notasNotificacion,
    archivosNotas,
    emails,
    formschema,
    formdata,/* 
    appfoundry, */
    representante,
    pcintegracion,
    actividades,
    cargaMasiva,
    customfieldsc,
    aplicacionesexternas,
    paises,
    loggeneral,
    geolocalizacion,
    paramcasoscorreos,
    casillascorreos,
    serviciotelefonico,
    serviciotelefonicoget,
    serviciotelefonicoadmin,
    parametrosAzure,
    respuestaspredefinidas,
    listacorreos,
    customfieldsvalues,
    segmentaciones,
    usuarioambiente,
    ambientesdestino,
    parametrosKeycloak,
    keycloakIp,
    usuarioEstadoDefault,
    rolEstadoDefault,
    catalogodocumentos,
    gestordocumental,
    hyperpersonalization,
    perfilUsuarios
  }
})
